import {
  FieldMappingListField,
  FieldMappingListFieldProps,
} from '@components/field-mapping-field/field-mapping-list-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingListFieldProps<T = unknown> = FormFieldProps<
  FieldMappingListFieldProps,
  T
>;

export function FormFieldMappingListField<T>(props: FormFieldMappingListFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping-list' });

  return <FieldMappingListField {...props} {...formFieldProps} />;
}
